import Input from "@/app/components/ui/Inputs/Input";
import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useState } from "react";
import { useForm } from "react-hook-form";

const ImageCategoryContent = ({ setCategory }) => {
  const formHook = useForm();
  return (
    <div className="justify-start items-baseline gap-16 inline-flex">
      <div className="p-2.5 justify-start items-center gap-2.5 flex">
        <div className="text-black text-xs font-normal">Name</div>
      </div>
      <div className="h-9 justify-center items-center gap-2.5 flex">
        <div className="h-9 w-[300px] mt-2">
          <Input
            register={formHook.register("name", {
              required: false,
            })}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCategory(e.target.value)}
            errorMessages={[]}
            className="h-9 w-[300px] rounded-md border-slate-400"
            fieldError={formHook.formState.errors.name}
            placeholder="Enter Name"
          />
        </div>
      </div>
    </div>
  );
};
const ImageCategoryModal = () => {
  const [category, setCategory] = useState("");
  const { setModalData: setImgCategory } = useModalActions("IMAGE_CATEGORY_MODAL");
  return (
    <ModalPrompt
      modalId="IMAGE_CATEGORY_MODAL"
      showIcon={false}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: "Save",
        secondaryButtonText: "Cancel",
        primaryButtonClassname:
          "px-6 cursor-pointer py-[9px] bg-sky-900 hover:bg-sky-900 rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex",
        primaryCallback: () => {
          // console.log(category);
          setImgCategory(category);
          setCategory("");
        },
        shouldHideOnClick: true,
      }}
      title="Add New Image Category"
      content={<ImageCategoryContent setCategory={setCategory} />}
    />
  );
};

export default ImageCategoryModal;
